import React from 'react';

import InputErrors from '../../common/InputErrors';
import Modal from '../../common/Modal';

function RegisterConfirmationModal({ visible, toggleModal, resend, emailResent, errors }) {
  return (
    <Modal
      toggleModal={toggleModal}
      visible={visible}
      centered
    >
      <div className="text">
        <h2>
          An Email Has Been Sent
        </h2>
        <p>
          Please check your email and follow the instructions to confirm your account
        </p>
      </div>
      {errors.length !== 0 && <InputErrors errors={errors} />}
      <p className="modal__meta">
        Didn’t get an email?
      </p>
      <button
        type="button"
        className="button button--large"
        onClick={resend}
      >
        Resend Email
      </button>
      {emailResent && (
        <div className="modal__response">
          Email has been resent.
        </div>
      )}
    </Modal>
  );
}

export default RegisterConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/features/account/RegisterConfirmationModal.js